import { BREEZE_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
import quickFetch from 'quick-fetch';
import Raven from 'raven-js';
import { getLatestOrCreateNewRpc, getThreadWithMessagesRpc, listForPortalUserRpc, softDeleteAndGetLatestOrCreateNewRpc, softDeleteRpc } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotThreadsService';
import { getThreadWithMessagesRpc as getThreadWithMessagesRpcV1, softDeleteThreadRpc as softDeleteThreadRpcV1 } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotThreadsService';
import { THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V2 } from '../../constants/threads';
import { httpClient } from '../../http/httpClient';
import { rpcClient } from '../../http/rpcClient';
export const fetchAllThreads = () => {
  return httpClient.get(`chatspot-high-volume/v1/threads`);
};
export const createNewThread = ({
  assistantType = BREEZE_COPILOT,
  customCopilotId
}) => {
  return httpClient.post(`chatspot/v1/threads`, {
    customCopilotId,
    query: {
      assistantType
    }
  });
};
export const deleteThreadById = id => {
  return httpClient.delete(`chatspot/v1/threads/${id}`);
};
const getLatestOrCreateNewRegularFetch = args => {
  return httpClient.get(`chatspot-high-volume/v1/threads/latest-or-new/?threadId=${args.threadId}&timeZoneOffset=${args.timeZoneOffset}&latestActivityTimestamp=${args.latestActivityTimestamp}&messagesLimit=${args.messagesLimit}`);
};
export const getLatestOrCreateNew = args => {
  const earlyAuthRequest = quickFetch.getRequestStateByName('getLatestOrCreateNew');
  if (earlyAuthRequest) {
    return new Promise((resolve, reject) => {
      earlyAuthRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest('getLatestOrCreateNew');
      });
      earlyAuthRequest.onError(() => {
        getLatestOrCreateNewRegularFetch(args).then(resolve, reject).catch(e => Raven.captureException(e));
        quickFetch.removeEarlyRequest('getLatestOrCreateNew');
      });
    });
  } else {
    return getLatestOrCreateNewRegularFetch(args);
  }
};
export const getThreadPage = ({
  id,
  limit,
  offset
}) => httpClient.get(`chatspot-high-volume/v1/threads/${id}`, {
  query: {
    messagesLimit: limit,
    messagesOffset: offset
  }
});
export const getThreadMetadata = id => httpClient.get(`chatspot-high-volume/v1/threads/${id}/metadata`);
export const mergeWithLatestThread = id => {
  return httpClient.post(`chatspot/v1/threads/${id}/merge-with-latest`);
};

// Copilot V2 endpoints
export const getLatestOrCreateThread = ({
  threadId,
  customCopilotId,
  latestUserActivityAt,
  messageLimit,
  previewKey,
  previewSource
}) => {
  return rpcClient.callWithResultUnion(getLatestOrCreateNewRpc, {
    request: {
      customCopilotId,
      latestUserActivityAt,
      messageLimit,
      threadId,
      previewKey,
      previewSource
    }
  });
};
export const getThreadWithMessages = ({
  threadId,
  messageOffset
}) => {
  return rpcClient.call(getThreadWithMessagesRpc, {
    request: {
      threadId,
      messageLimit: THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V2,
      messageOffset
    }
  });
};
export const getThreadWithMessagesForV1 = ({
  threadId,
  messageOffset
}) => {
  return rpcClient.call(getThreadWithMessagesRpcV1, {
    request: {
      threadId,
      messageLimit: THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V2,
      messageOffset
    }
  });
};
export const getListForPortalUser = ({
  limit,
  offset
}) => {
  return rpcClient.call(listForPortalUserRpc, {
    request: {
      limit,
      offset
    }
  });
};
export const deleteThread = ({
  threadId
}) => {
  return rpcClient.call(softDeleteRpc, {
    request: {
      threadId
    }
  });
};
export const softDeleteThreadV1ForV2 = ({
  threadId
}) => {
  return rpcClient.call(softDeleteThreadRpcV1, {
    request: {
      threadId
    }
  });
};
export const softDeleteAndGetLatestOrCreateNew = ({
  threadIdToDelete,
  customCopilotId,
  messageLimit
}) => {
  return rpcClient.call(softDeleteAndGetLatestOrCreateNewRpc, {
    request: {
      threadIdToDelete,
      customCopilotId,
      messageLimit: messageLimit || THREAD_INITIAL_MESSAGES_COUNT_TO_FETCH_V2
    }
  });
};